export interface FormFooter {
    cc: string;
  }
  export const defaultFormFooter: FormFooter = {
    cc: "",
  };
  